const CHATWOOT_SCRIPT_SRC = `${process.env.PUBLIC_URL || ''}/chatwoot.js`;

function loadChatwootBootstrap() {
  return new Promise((resolve, reject) => {
    if (typeof window.initRecrutChatwoot === 'function') {
      resolve();
      return;
    }

    const existing = document.querySelector(`script[src="${CHATWOOT_SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener(
        'error',
        () => reject(new Error('Failed to load Chatwoot bootstrap')),
        { once: true }
      );
      return;
    }

    const script = document.createElement('script');
    script.src = CHATWOOT_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Chatwoot bootstrap'));
    document.body.appendChild(script);
  });
}

function formatPhoneNumber(phoneMobile, phoneCountry) {
  if (!phoneMobile) return '';

  const digits = String(phoneMobile).replace(/\D/g, '');
  if (!digits) return '';

  if (!phoneCountry) return digits;

  const country = String(phoneCountry).replace(/\D/g, '');
  return country ? `+${country}${digits}` : digits;
}

export default (id, name, email, identifierHash, companyName, phoneMobile, phoneCountry) => {
  if (!id || !identifierHash) return;

  const phoneNumber = formatPhoneNumber(phoneMobile, phoneCountry);

  const chatwootIdentify = () => {
    if (!window.$chatwoot) return;

    // Do NOT call reset() here — it belongs to logout only.
    // reset() before setUser cancels the request and wipes conversation history on every F5.
    window.$chatwoot.setUser(String(id), {
      company_name: companyName || '',
      email: email || '',
      identifier_hash: identifierHash,
      name: name || '',
      ...(phoneNumber ? { phone_number: phoneNumber } : {})
    });

    if (typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
      window.$chatwoot.toggleBubbleVisibility('show');
    }
  };

  loadChatwootBootstrap()
    .then(() => {
      if (typeof window.initRecrutChatwoot !== 'function') return;
      window.initRecrutChatwoot(chatwootIdentify);
    })
    .catch((err) => {
      console.error(err);
    });
};
